// @ts-nocheck



import { fetchRequest } from './index';



export const getFileResource = async (
resource) =>
{
  const list = await fetchRequest.get(`/file/${resource}`);
  if (list) return list;
  throw new Error('Не удалось получить список файлов');
};

export const deleteFile = async (id) => {
  const file = await fetchRequest.delete(`/file/${id}`);
  if (file) return file;
  throw new Error('Не удалось удалить файл');
};

export const postFile = async (file) => {
  const fileInfo = await fetchRequest.post(`/file`, file);
  if (fileInfo) return fileInfo;
  throw new Error('Не удалось добавить файл');
};

export default {
  getFileResource,
  deleteFile,
  postFile
};
